import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, Alignment, BreakableRenderer, ColumnComposition, ColumnCompositions, LetterDimensions, RowPanel, SquareRenderer } from '@blk/simba';
import { CellData, TabData } from '@ddt-web/data-service';
import { HoldingsColumnComposition, TableCompositionHelper } from '@ddt-web/pdf-components';

export class HoldingsTableUtil {
	public static getTablePanels(tabData: TabData, contentSvc: ContentService, modelNames: string[], showColorForNumber: boolean = false): Array<AbstractRenderer<SVGGElement>> {
		const panels: Array<AbstractRenderer<SVGGElement>> = [];
		const columnConfigurations: ColumnCompositions[] = new HoldingsColumnComposition().getHoldingsCompositions(tabData, null, null, contentSvc, showColorForNumber, true);

		if (!columnConfigurations) {
			console.error(`Column configurations are not defined, table: ${this.name} will not render!`);
			return;
		}

		const rows: Array<RowPanel> = [];
		columnConfigurations.forEach((config, index) => {
			const headerBorderRow: RowPanel = new RowPanel(
				'Asset Class Color Row',
				[new SquareRenderer(tabData?.tableData[0]?.headersY[index]?.attribute?.backgroundColor, {}, LetterDimensions.LANDSCAPE_WIDTH_CONTENT, 3)]
			);
			const sumRow: RowPanel = new RowPanel(
				'Summation Row',
				config.headers.map((config: ColumnComposition) => config.renderer.render()),
				{ paddingLeft: 2, marginTop: 0.1 },
				Alignment.Horizontal.Left,
				Alignment.Vertical.Middle
			);
			rows.push(headerBorderRow);
			rows.push(sumRow);

			config.body.forEach((configs: Array<ColumnComposition>, index: number) => {
				const rowRenderer = configs.map((config: ColumnComposition) => config.renderer.render());
				rows.push(
					new RowPanel(
						'Portfolio Table Rows',
						rowRenderer,
						{ paddingLeft: 2, paddingBottom: 0, backgroundColor: '#FFFFFF' },
						Alignment.Horizontal.Left,
						Alignment.Vertical.Middle
					)
				);
			});
		});

		panels.push(new BreakableRenderer(rows, {}, this.getHeaderRow(modelNames)));
		return panels;
	}

	public static getHeaderRow(modelNames: string[], marginBottom: number = 0): AbstractRenderer<SVGGElement> {
		return new RowPanel('Model Names Row', this.createModelNamesColumns(modelNames).map((config: ColumnComposition) => config.renderer.render()), {
			marginTop: 0.1,
			marginBottom: marginBottom,
			paddingLeft: 2
		},
		Alignment.Horizontal.Right,
		Alignment.Vertical.Middle
		);
	}

	public static createModelNamesColumns(modelNames): ColumnComposition[] {
		const headerColumnProportions = TableCompositionHelper.getHoldingsColumnProportions(modelNames.length - 1, true, true);
		return modelNames.map((name: string, index: number) => {
			return new ColumnComposition({
				cells: CellData.create({ config: null, rawValue: name, formattedValue: name, parent: null, attribute: null, children: null }),
				widthProportion: headerColumnProportions[index],
				textClasses: ['text-bold', 'text-8'],
				horizontalAlignment: Alignment.Horizontal.Right,
				verticalAlignment: Alignment.Vertical.Middle,
				boxModelConstraint: { paddingRight: TableCompositionHelper.getTableColumnBoxModelConstraints((modelNames.length - 1), true) }
			});
		});
	}

	// temp fix to wrap long words
	// doesn't support model names with more than two words
	// TODO dpurohit: we should aim to get shortnames from upstream
	public static wrapModelNames(modelNames: string[]): string[] {
		return modelNames?.map(modelName => {
			const modelNameParts = modelName.split(' ');
			return modelNameParts.length === 2
				? `${modelNameParts[0]}<br>${modelNameParts[1]}</br>`
				: modelName;
		}) || [];
	}
}
